'use client';

import { c as _c } from "react/compiler-runtime";
import { Loader as RedesignLoader } from '@systemeio/components';
interface LoaderProps {
  small?: boolean;
  type?: 'light' | 'dark';
  className?: string;
}
function Loader(t0) {
  const $ = _c(8);
  const {
    small: t1,
    type: t2,
    className
  } = t0;
  const small = t1 === undefined ? false : t1;
  const type = t2 === undefined ? "light" : t2;
  const t3 = type === "dark" ? "secondary" : "primary";
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      "aria-hidden": true
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const t5 = small ? "md" : "xl";
  let t6;
  if ($[1] !== t3 || $[2] !== t5) {
    t6 = <RedesignLoader color={t3} rootProps={t4} size={t5} />;
    $[1] = t3;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="sr-only">Loading...</span>;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== className || $[6] !== t6) {
    t8 = <div role="status" className={className}>{t6}{t7}</div>;
    $[5] = className;
    $[6] = t6;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  return t8;
}
export { Loader };
export type { LoaderProps };